import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "products-page" };
const _hoisted_2 = { class: "products-layout" };
const _hoisted_3 = { class: "products-list-panel" };
const _hoisted_4 = { class: "list-header" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { class: "search-box" };
const _hoisted_7 = { class: "products-list" };
const _hoisted_8 = {
    key: 0,
    class: "product-items"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = { class: "product-name" };
const _hoisted_11 = {
    key: 0,
    class: "product-flag"
};
const _hoisted_12 = {
    key: 1,
    class: "empty-state"
};
const _hoisted_13 = { class: "product-details-panel" };
const _hoisted_14 = {
    key: 0,
    class: "details-content"
};
const _hoisted_15 = { class: "detail-header" };
const _hoisted_16 = { class: "top-actions" };
const _hoisted_17 = { class: "form-row" };
const _hoisted_18 = { class: "form-group" };
const _hoisted_19 = { class: "form-group" };
const _hoisted_20 = { class: "form-group" };
const _hoisted_21 = { class: "form-group checkbox" };
const _hoisted_22 = { class: "form-group checkbox" };
const _hoisted_23 = { class: "form-row three" };
const _hoisted_24 = { class: "form-group" };
const _hoisted_25 = { class: "form-group" };
const _hoisted_26 = { class: "form-group" };
const _hoisted_27 = { class: "form-row two" };
const _hoisted_28 = { class: "form-group" };
const _hoisted_29 = { class: "form-group" };
const _hoisted_30 = { class: "form-group" };
const _hoisted_31 = { class: "form-group" };
const _hoisted_32 = { class: "form-group" };
const _hoisted_33 = { class: "paragraphs-section" };
const _hoisted_34 = { class: "paragraphs-header" };
const _hoisted_35 = { class: "form-group" };
const _hoisted_36 = ["onUpdate:modelValue"];
const _hoisted_37 = {
    key: 0,
    class: "paragraph-id"
};
const _hoisted_38 = { class: "form-group" };
const _hoisted_39 = ["onUpdate:modelValue"];
const _hoisted_40 = ["onClick"];
const _hoisted_41 = { class: "form-row two" };
const _hoisted_42 = { class: "form-group" };
const _hoisted_43 = { class: "form-group" };
const _hoisted_44 = { class: "form-row three" };
const _hoisted_45 = { class: "form-group" };
const _hoisted_46 = { class: "form-group" };
const _hoisted_47 = { class: "form-group" };
const _hoisted_48 = { class: "form-group" };
const _hoisted_49 = {
    key: 1,
    class: "empty-state"
};
const _hoisted_50 = { class: "modal-header" };
const _hoisted_51 = { class: "modal-body" };
const _hoisted_52 = { class: "modal-footer" };
import { ref, computed, onMounted } from 'vue';
import { useAdmin } from '@/composables/useAdmin';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductsPage',
    setup(__props) {
        const admin = useAdmin();
        const products = ref(null);
        const product = ref(null);
        const search = ref('');
        const showDeleteConfirm = ref(false);
        const showSuccessToast = ref(false);
        const successMessage = ref('');
        const showErrorToast = ref(false);
        const errorMessage = ref('');
        const filteredProducts = computed(() => {
            if (!products.value)
                return [];
            if (!search.value.trim())
                return products.value;
            const query = search.value.toLowerCase();
            return products.value.filter((p) => (p.name || '').toLowerCase().includes(query));
        });
        function showToast(message) {
            successMessage.value = message;
            showSuccessToast.value = true;
        }
        function showError(message) {
            errorMessage.value = message || "Sorry, that didn't work, please contact Tris";
            showErrorToast.value = true;
        }
        function loadProducts(autoSelect) {
            admin.getProducts((result) => {
                products.value = result;
                if (autoSelect && result.length > 0) {
                    selectProduct(result[0]);
                }
            });
        }
        function selectProduct(p) {
            product.value = p;
        }
        function saveProduct() {
            const isNew = !product.value.id;
            admin.saveProduct(product.value, (result) => {
                product.value = result;
                loadProducts(false);
                showToast(isNew ? 'Product created OK!' : 'Product saved OK!');
            }, () => showError());
        }
        function addParagraph() {
            if (!product.value.paragraphs)
                product.value.paragraphs = [];
            product.value.paragraphs.push({ title: '', body: '' });
        }
        function removeParagraph(para) {
            const i = product.value.paragraphs.indexOf(para);
            if (i > -1)
                product.value.paragraphs.splice(i, 1);
        }
        function doDeleteSelected() {
            showDeleteConfirm.value = false;
            admin.deleteProduct(product.value.id, () => {
                product.value = null;
                loadProducts(true);
                showToast('Product deleted OK!');
            }, (error) => showError(error));
        }
        function newProduct() {
            product.value = {
                id: null,
                name: '',
                featured: false,
                tags: '',
                priority: 0,
                title: '',
                subTitle: '',
                tagLine: '',
                description: '',
                body: '',
                bodyListItems: '',
                actionButtonText: '',
                backgroundImage: '',
                backgroundVideo: '',
                thumbnail: '',
                websiteUrl: '',
                appScreen: '',
                cmsPage: '',
                paragraphs: [],
                enabled: true
            };
        }
        function onLoad() {
            loadProducts(true);
        }
        onMounted(onLoad);
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_snackbar = _resolveComponent("v-snackbar");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _cache[29] || (_cache[29] = _createElementVNode("h2", null, "Products", -1)),
                            (products.value)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(products.value.length) + " products", 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((search).value = $event)),
                                type: "text",
                                placeholder: "Search products...",
                                class: "search-input"
                            }, null, 512), [
                                [_vModelText, search.value]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                            (filteredProducts.value.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredProducts.value, (p) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: p.id,
                                            class: _normalizeClass(["product-item", { active: product.value && product.value.id === p.id }]),
                                            onClick: ($event) => (selectProduct(p))
                                        }, [
                                            _createElementVNode("span", _hoisted_10, _toDisplayString(p.name), 1),
                                            (!p.enabled)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, "disabled"))
                                                : _createCommentVNode("", true)
                                        ], 10, _hoisted_9));
                                    }), 128))
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_12, "No products found"))
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                        (product.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, _toDisplayString(product.value.id || 'New Product'), 1),
                                _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("button", {
                                        class: "action-btn primary",
                                        onClick: saveProduct
                                    }, _toDisplayString(product.value.id ? 'Save Changes' : 'Create Product'), 1),
                                    _createElementVNode("button", {
                                        class: "action-btn secondary",
                                        onClick: newProduct
                                    }, "New Product"),
                                    (product.value.id)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "action-btn secondary",
                                            onClick: onLoad
                                        }, "Reload"))
                                        : _createCommentVNode("", true),
                                    (product.value.id)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            class: "action-btn danger",
                                            onClick: _cache[1] || (_cache[1] = ($event) => (showDeleteConfirm.value = true))
                                        }, "Delete"))
                                        : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_17, [
                                    _createElementVNode("div", _hoisted_18, [
                                        _cache[30] || (_cache[30] = _createElementVNode("label", null, "Name:", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((product.value.name) = $event)),
                                            type: "text",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, product.value.name]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_19, [
                                        _cache[31] || (_cache[31] = _createElementVNode("label", null, "Tags (, delimited):", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((product.value.tags) = $event)),
                                            type: "text",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, product.value.tags]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_20, [
                                        _cache[32] || (_cache[32] = _createElementVNode("label", null, "Priority:", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((product.value.priority) = $event)),
                                            type: "number",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, product.value.priority]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_21, [
                                        _createElementVNode("label", null, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((product.value.enabled) = $event)),
                                                type: "checkbox",
                                                class: "form-checkbox"
                                            }, null, 512), [
                                                [_vModelCheckbox, product.value.enabled]
                                            ]),
                                            _cache[33] || (_cache[33] = _createTextVNode(" Enabled"))
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_22, [
                                        _createElementVNode("label", null, [
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((product.value.featured) = $event)),
                                                type: "checkbox",
                                                class: "form-checkbox"
                                            }, null, 512), [
                                                [_vModelCheckbox, product.value.featured]
                                            ]),
                                            _cache[34] || (_cache[34] = _createTextVNode(" Featured"))
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_23, [
                                    _createElementVNode("div", _hoisted_24, [
                                        _cache[35] || (_cache[35] = _createElementVNode("label", null, "Thumbnail (or calculator specific):", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((product.value.thumbnail) = $event)),
                                            type: "text",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, product.value.thumbnail]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_25, [
                                        _cache[36] || (_cache[36] = _createElementVNode("label", null, "Featured Tag line:", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((product.value.featuredTagLine) = $event)),
                                            type: "text",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, product.value.featuredTagLine]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_26, [
                                        _cache[37] || (_cache[37] = _createElementVNode("label", null, "Tag Line:", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((product.value.tagLine) = $event)),
                                            type: "text",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, product.value.tagLine]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("div", _hoisted_28, [
                                        _cache[38] || (_cache[38] = _createElementVNode("label", null, "Title:", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((product.value.title) = $event)),
                                            type: "text",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, product.value.title]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_29, [
                                        _cache[39] || (_cache[39] = _createElementVNode("label", null, "Subtitle:", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((product.value.subTitle) = $event)),
                                            type: "text",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, product.value.subTitle]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_30, [
                                    _cache[40] || (_cache[40] = _createElementVNode("label", null, "Intro:", -1)),
                                    _withDirectives(_createElementVNode("textarea", {
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((product.value.intro) = $event)),
                                        class: "form-textarea",
                                        rows: "5"
                                    }, null, 512), [
                                        [_vModelText, product.value.intro]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_31, [
                                    _cache[41] || (_cache[41] = _createElementVNode("label", null, "Product page description:", -1)),
                                    _withDirectives(_createElementVNode("textarea", {
                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((product.value.description) = $event)),
                                        class: "form-textarea",
                                        rows: "5"
                                    }, null, 512), [
                                        [_vModelText, product.value.description]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_32, [
                                    _cache[42] || (_cache[42] = _createElementVNode("label", null, "Product page bullets (, delimited):", -1)),
                                    _withDirectives(_createElementVNode("textarea", {
                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((product.value.bodyListItems) = $event)),
                                        class: "form-textarea",
                                        rows: "3"
                                    }, null, 512), [
                                        [_vModelText, product.value.bodyListItems]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_33, [
                                    _createElementVNode("div", _hoisted_34, [
                                        _createElementVNode("h3", null, "Paragraphs (" + _toDisplayString((product.value.paragraphs || []).length) + ")", 1),
                                        _createElementVNode("button", {
                                            class: "action-btn secondary",
                                            onClick: addParagraph
                                        }, "Add paragraph")
                                    ]),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.value.paragraphs, (para, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: index,
                                            class: "paragraph-item"
                                        }, [
                                            _createElementVNode("div", _hoisted_35, [
                                                _cache[43] || (_cache[43] = _createElementVNode("label", null, "Heading:", -1)),
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": ($event) => ((para.title) = $event),
                                                    type: "text",
                                                    class: "form-input"
                                                }, null, 8, _hoisted_36), [
                                                    [_vModelText, para.title]
                                                ])
                                            ]),
                                            (para.id)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                                    _createElementVNode("small", null, _toDisplayString(para.id), 1)
                                                ]))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("div", _hoisted_38, [
                                                _cache[44] || (_cache[44] = _createElementVNode("label", null, "Body:", -1)),
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": ($event) => ((para.body) = $event),
                                                    type: "text",
                                                    class: "form-input"
                                                }, null, 8, _hoisted_39), [
                                                    [_vModelText, para.body]
                                                ])
                                            ]),
                                            _createElementVNode("button", {
                                                class: "action-btn danger",
                                                onClick: ($event) => (removeParagraph(para))
                                            }, "Delete", 8, _hoisted_40)
                                        ]));
                                    }), 128))
                                ]),
                                _createElementVNode("div", _hoisted_41, [
                                    _createElementVNode("div", _hoisted_42, [
                                        _cache[45] || (_cache[45] = _createElementVNode("label", null, "Product page img (or calculator type img):", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event) => ((product.value.backgroundImage) = $event)),
                                            type: "text",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, product.value.backgroundImage]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_43, [
                                        _cache[46] || (_cache[46] = _createElementVNode("label", null, "Product page CTA:", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((product.value.actionButtonText) = $event)),
                                            type: "text",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, product.value.actionButtonText]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_44, [
                                    _createElementVNode("div", _hoisted_45, [
                                        _cache[47] || (_cache[47] = _createElementVNode("label", null, "Website:", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event) => ((product.value.websiteUrl) = $event)),
                                            type: "text",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, product.value.websiteUrl]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_46, [
                                        _cache[48] || (_cache[48] = _createElementVNode("label", null, "App Screen:", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((product.value.appScreen) = $event)),
                                            type: "text",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, product.value.appScreen]
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_47, [
                                        _cache[49] || (_cache[49] = _createElementVNode("label", null, "CMS Page:", -1)),
                                        _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((product.value.cmsPage) = $event)),
                                            type: "text",
                                            class: "form-input"
                                        }, null, 512), [
                                            [_vModelText, product.value.cmsPage]
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_48, [
                                    _cache[50] || (_cache[50] = _createElementVNode("label", null, "Employer ID (benefits only):", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((product.value.employerID) = $event)),
                                        type: "text",
                                        class: "form-input"
                                    }, null, 512), [
                                        [_vModelText, product.value.employerID]
                                    ])
                                ])
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_49, "Select a product to view details"))
                    ])
                ]),
                (showDeleteConfirm.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "modal-overlay",
                        onClick: _cache[24] || (_cache[24] = ($event) => (showDeleteConfirm.value = false))
                    }, [
                        _createElementVNode("div", {
                            class: "modal-dialog",
                            onClick: _cache[23] || (_cache[23] = _withModifiers(() => { }, ["stop"]))
                        }, [
                            _createElementVNode("div", _hoisted_50, [
                                _cache[51] || (_cache[51] = _createElementVNode("h3", null, "Delete Product", -1)),
                                _createElementVNode("button", {
                                    class: "close-btn",
                                    onClick: _cache[21] || (_cache[21] = ($event) => (showDeleteConfirm.value = false))
                                }, "✕")
                            ]),
                            _createElementVNode("div", _hoisted_51, [
                                _createElementVNode("p", null, [
                                    _cache[52] || (_cache[52] = _createTextVNode("Are you sure you want to delete ")),
                                    _createElementVNode("strong", null, _toDisplayString(product.value && product.value.name), 1),
                                    _cache[53] || (_cache[53] = _createTextVNode("?"))
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_52, [
                                _createElementVNode("button", {
                                    class: "action-btn danger",
                                    onClick: doDeleteSelected
                                }, "Yes, Delete"),
                                _createElementVNode("button", {
                                    class: "action-btn secondary",
                                    onClick: _cache[22] || (_cache[22] = ($event) => (showDeleteConfirm.value = false))
                                }, "Cancel")
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(_component_v_snackbar, {
                    modelValue: showSuccessToast.value,
                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => ((showSuccessToast).value = $event)),
                    timeout: 3000,
                    location: "bottom",
                    color: "success"
                }, {
                    actions: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                            icon: "mdi-close",
                            size: "small",
                            onClick: _cache[25] || (_cache[25] = ($event) => (showSuccessToast.value = false))
                        })
                    ]),
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(successMessage.value) + " ", 1)
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_v_snackbar, {
                    modelValue: showErrorToast.value,
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event) => ((showErrorToast).value = $event)),
                    timeout: 4000,
                    location: "bottom",
                    color: "error"
                }, {
                    actions: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                            icon: "mdi-close",
                            size: "small",
                            onClick: _cache[27] || (_cache[27] = ($event) => (showErrorToast.value = false))
                        })
                    ]),
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(errorMessage.value) + " ", 1)
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ]));
        };
    }
});
